import styled from 'styled-components';

export const HeaderStyles = styled.header`
  background: #FFC228;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  
  .contentWrapper {
    opacity: 0;
    transition: 1s linear all;
    
    &.active {
      opacity: 1;
    }
  }
  
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .logo {
      position: relative;
      padding-top: 8px;
      padding-left: 20px;
      
      svg {
        position: relative;
        z-index: 1;
        
        @media (max-width: 900px) {
          height: 40px;
          transform: translateX(-14px);
        }
      }
      
      &::after {
        position: absolute;
        content: '';
        top: 0;
        height: 88px;
        width: 107px;
        background: #000;
        left: 0;
        
        @media (max-width: 900px) {
          width: 76px;
          height: 64px;
        }
      }
    }
    
    .menuWrapper {
      display: flex;
      align-items: center;
      gap: 32px;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      height: 100%;
      
      @media (max-width: 1100px) {
        gap: 16px;
      }
      
      @media (max-width: 900px) {
        
      }
      
      .langButton {
        position: relative;

        &::after {
          content: "";
          position: absolute;
          background: #1b1f2c;
          text-align: center;
          opacity: 1;
          z-index: -1;
          top: -23px;
          width: calc(100% + 32px);
          left: -16px;
          border-bottom: 2px solid #ffc328;
          box-shadow: 0 0 4px rgb(0 0 0 / 14%), 0 4px 8px rgb(0 0 0 / 28%);
          height: 87px;
          transform: translateY(calc(-100% - 10px));
          transition: .3s ease all;

          @media (max-width: 1100px) {
            width: calc(100% + 16px);
            left: -8px;
          }
        }

        &:hover {
          &::after {
            transform: translateY(0);
          }

            color: #FFF;
          
        }

          color: #000;
          transition: 0.3s ease color;
      }
      
      button {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;

        @media (max-width: 900px) {

        }
      }

      .splitter {
        height: 24px;
        width: 2px;
        background: #000;

        @media (max-width: 900px) {

        }
      }
      
      ul {
        display: flex;
        gap: 24px;

        @media (max-width: 1250px) {
          gap: 16px;
        }

        @media (max-width: 1150px) {
          display: none;
        }
        
        li {
          position: relative;
          
          &::after {
            content: "";
            position: absolute;
            background: #1b1f2c;
            text-align: center;
            opacity: 1;
            z-index: -1;
            top: -25px;
            width: calc(100% + 32px);
            left: -16px;
            border-bottom: 2px solid #ffc328;
            box-shadow: 0 0 4px rgb(0 0 0 / 14%), 0 4px 8px rgb(0 0 0 / 28%);
            height: 87px;
            transform: translateY(calc(-100% - 10px));
            transition: .3s ease all;

            @media (max-width: 1100px) {
              width: calc(100% + 16px);
              left: -8px;
            }
          }
          
          &:hover {
            &::after {
              transform: translateY(0);
            }
            
            a {
              color: #FFF;
            }
          }

          a {
            color: #000;
            position: relative;
            transition: 0.3s ease color;
          }
        }
      }
    }
    
    .menuButton {
      display: none;
      
      width: 28px;
      height: 20px;
      flex-direction: column;
      justify-content: space-between;
      
      @media (max-width: 1150px) {
        display: flex;
      }
      
      div {
        width: 100%;
        height: 3px;
        border-radius: 10px;
        background: #000;
      }
    }
  }
`;
